// Dedicated Server product data.
// Translatable UI text uses tPrefix to look up i18n keys.
// Spec values (CPU, RAM, Storage) are product content and stay as-is.

export const DEDICATED_TYPES = [
  {
    slug: 'standard',
    tPrefix: 'standard',
    fromPrice: '31.20',
    orderUrl: 'https://deinserverhost.de/en/dedicated-servers',
    servers: [
      {
        name: 'Core i3 12100F',
        cpu: 'Intel Core i3 12100F',
        cores: '4 Cores / 8 Threads',
        ram: '16 GB DDR4',
        storage: '500 GB SSD',
        network: '1 Gbit/s',
        price: '31.20',
        setup: '0.00',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=555',
      },
      {
        name: 'Ryzen 3 4300GE',
        cpu: 'AMD Ryzen 3 4300GE',
        cores: '4 Cores / 8 Threads',
        ram: '16 GB DDR4',
        storage: '500 GB NVMe',
        network: '1 Gbit/s',
        price: '39.95',
        setup: '0.00',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=549',
      },
      {
        name: 'Ryzen 7 3700X',
        cpu: 'AMD Ryzen 7 3700X',
        cores: '8 Cores / 16 Threads',
        ram: '16 GB DDR4',
        storage: '500 GB NVMe',
        network: '1 Gbit/s',
        price: '47.73',
        setup: '0.00',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=548',
      },
      {
        name: 'Ryzen 5 5600G',
        cpu: 'AMD Ryzen 5 5600G',
        cores: '6 Cores / 12 Threads',
        ram: '16 GB DDR4',
        storage: '500 GB NVMe',
        network: '1 Gbit/s',
        price: '50.96',
        setup: '9.95',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=527',
      },
      {
        name: 'Ryzen 7 5700G',
        cpu: 'AMD Ryzen 7 5700G',
        cores: '8 Cores / 16 Threads',
        ram: '16 GB DDR4',
        storage: '500 GB NVMe',
        network: '1 Gbit/s',
        price: '58.45',
        setup: '9.95',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=528',
      },
      {
        name: 'Ryzen 7 5800X',
        cpu: 'AMD Ryzen 7 5800X',
        cores: '8 Cores / 16 Threads',
        ram: '16 GB DDR4',
        storage: '500 GB NVMe',
        network: '1 Gbit/s',
        price: '66.56',
        setup: '9.95',
        popular: true,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=552',
      },
      {
        name: 'Ryzen 9 5900X',
        cpu: 'AMD Ryzen 9 5900X',
        cores: '12 Cores / 24 Threads',
        ram: '16 GB DDR4',
        storage: '500 GB NVMe',
        network: '1 Gbit/s',
        price: '90.48',
        setup: '9.95',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=492',
      },
      {
        name: 'Core i7 13700KF',
        cpu: 'Intel Core i7 13700KF',
        cores: '16 Cores / 24 Threads',
        ram: '32 GB DDR4',
        storage: '500 GB NVMe',
        network: '1 Gbit/s',
        price: '113.37',
        setup: '9.95',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=588',
      },
      {
        name: 'Ryzen 9 7900X',
        cpu: 'AMD Ryzen 9 7900X',
        cores: '12 Cores / 24 Threads',
        ram: '32 GB DDR5',
        storage: '500 GB NVMe',
        network: '1 Gbit/s',
        price: '120.64',
        setup: '9.95',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=585',
      },
      {
        name: 'Core i9 13900KF',
        cpu: 'Intel Core i9 13900KF',
        cores: '24 Cores / 32 Threads',
        ram: '32 GB DDR4',
        storage: '500 GB NVMe',
        network: '1 Gbit/s',
        price: '130.00',
        setup: '9.95',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=589',
      },
    ],
  },
  {
    slug: 'premium',
    tPrefix: 'premium',
    fromPrice: '189.95',
    orderUrl: 'https://deinserverhost.de/en/premium-dedicated-servers',
    servers: [
      {
        name: 'Ryzen 7 3700X Premium',
        cpu: 'AMD Ryzen 7 3700X',
        cores: '8 Cores / 16 Threads',
        ram: '128 GB DDR4',
        storage: '1 TB NVMe',
        network: '10 Gbit/s',
        price: '189.95',
        setup: '39.95',
        popular: true,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=595',
      },
      {
        name: 'Ryzen 9 5900X Premium',
        cpu: 'AMD Ryzen 9 5900X',
        cores: '12 Cores / 24 Threads',
        ram: '128 GB DDR4',
        storage: '1 TB NVMe',
        network: '10 Gbit/s',
        price: '249.95',
        setup: '39.95',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=596',
      },
      {
        name: 'Core i7 13700KF Premium',
        cpu: 'Intel Core i7 13700KF',
        cores: '16 Cores / 24 Threads',
        ram: '128 GB DDR4',
        storage: '1 TB NVMe',
        network: '10 Gbit/s',
        price: '299.95',
        setup: '39.95',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=597',
      },
      {
        name: 'Core i9 13900KF Premium',
        cpu: 'Intel Core i9 13900KF',
        cores: '24 Cores / 32 Threads',
        ram: '128 GB DDR4',
        storage: '1 TB NVMe',
        network: '10 Gbit/s',
        price: '349.95',
        setup: '39.95',
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=598',
      },
    ],
  },
];

export function getDedicatedBySlug(slug) {
  return DEDICATED_TYPES.find((d) => d.slug === slug) || null;
}
